{ attachmentsDomain } = require '@trello/config'
parseURL = require 'url-parse'
isTrello = require './is-trello'

module.exports = (url) ->
  if url.indexOf(attachmentsDomain) == 0
    return true
  parseURL(url).pathname.match(/^\/1\/cards\/[a-f0-9]{24}\/attachments\/[a-f0-9]{24}\/download\/.*/) && isTrello(url)
